import {
  faCalendarAlt,
  faClipboardList,
  faMapMarkerAlt,
  faHome,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../utils/factory/createField";

export const shipmentItemFields = [
  {
    section: "Informações do Item do Carregamento",
    fields: [
      createField({
        id: "movement_item_id",
        label: "Item do Movimento",
        type: "select",
        icon: faClipboardList,
        placeholder: "Selecione o Item do Movimento",
      }),
      createField({
        id: "address_id",
        label: "Endereço",
        type: "select",
        icon: faHome,
        placeholder: "Selecione o Endereço",
      }),
      createField({
        id: "location_id",
        label: "Localização",
        type: "select",
        icon: faMapMarkerAlt,
        placeholder: "Selecione a Localização",
      }),
      createField({
        id: "details",
        label: "Detalhes",
        type: "textarea",
        placeholder: "Digite os detalhes",
        icon: faInfoCircle,
        fullWidth: true,
      }),
    ],
  },
];

export const detailsShipmentItemFields = [
  {
    section: "Informações do Equipamento",
    fields: [
      createField({
        id: "item_name",
        label: "Equipamento",
        type: "text",
        icon: faClipboardList,
        placeholder: "Selecione o Item",
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: "delivery_date",
        label: "Data de Entrega",
        type: "text",
        placeholder: "Selecione a Data de Entrega",
        icon: faCalendarAlt,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: "address",
        label: "Endereço Destino",
        type: "text",
        icon: faHome,
        placeholder: "Selecione o Endereço",
        disabled: true,
      }),
      createField({
        id: "location",
        label: "Localização Destino",
        type: "text",
        icon: faMapMarkerAlt,
        placeholder: "Selecione a Localização",
        disabled: true,
      }),
      createField({
        id: "details",
        label: "Detalhes",
        type: "textarea",
        placeholder: "Digite os detalhes",
        icon: faInfoCircle,
        fullWidth: true,
        disabled: true,
      }),
    ],
  },
];
